import useGetData from 'Hooks/useGetData'

const useRiskAssessmentDetail = (assessmentId, enabled) => {
  const url = enabled && assessmentId ? `/rapi/riskassessments/${assessmentId}` : null
  const [isLoading, data] = useGetData(url, null, [url])

  return {
    isLoading: !!url && isLoading,
    product: data?.product ?? null,
    riskAssessment: data?.risk_assessment ?? null
  }
}

export default useRiskAssessmentDetail
